import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/",
          name: "main",
          component: () => import("@/view/pages/Dashboard.vue")
        },
        {
          path: "/patients",
          name: "patients",
          component: () => import("@/view/pages/Patients.vue")
        },
        {
          path: "/patient/:id",
          name: "patient",
          component: () => import("@/view/pages/Patient.vue")
        },
        {
          path: "/instruction",
          name: "instruction",
          component: () => import("@/view/pages/Instruction.vue")
        },
        {
          path: "/faq",
          name: "faq",
          component: () => import("@/view/pages/FAQ.vue")
        },
        {
          path: "/notifications",
          name: "notifications",
          component: () => import("@/view/pages/Notifications.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/login_pages/Login-1")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
